module.exports = __webpack_public_path__ + "img/gywm (1).7c26be42.png";